import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import userService from './../Services/user';
import { NavLink } from 'react-router-dom'; 
import Toast from './../Components/common/Toast';

import { useDispatch } from 'react-redux';

import { setUserData, changeBackground } from '../Redux/actions';

const Login = (props) =>{
    const dispatch = useDispatch();

    const errorsInitialState = { username: false, password: false};
    const userInitialState ={ username: '', password: ''};
    
    const [user, setUser] = useState(userInitialState);
    const [errors, setErrors] = useState(errorsInitialState);
    const [toastMessage, setToastMessage] = useState('')

    const handleChange = (e) =>{
        const {name, value} = e.target;
        setUser({...user, [name]:value});
        if(!value) setErrors({...errors, [name]: true})
        else setErrors({...errors, [name]: false})
    }

    const validateForm = () =>{
        const { username, password } = user;
        let uFlag = false, passFlag = false;
        if (!username) uFlag = true;
        if (!password) passFlag = true;
        setErrors({username: uFlag, password: passFlag});
        if(!username || !password) return false;
        else return true;
    }

    const handleSubmit = async() =>{
        if(validateForm()){
            const res = await userService.Login(user);
            console.log(res)
            if(res.success){
                dispatch(setUserData(res));
                dispatch(changeBackground(res.bgImg ?? 1));
                props.history.push('/main')
            }
            else{
                setErrors({username:true, password:true})
                setToastMessage(res.message)
            }
        }
    }

    const getlogged = e => {
        if (e.key === 'Enter') handleSubmit()
    }

    return(
        <Container fluid className='p-0 m-0 d-flex justify-content-center align-content-center vh-100 w-100 flex-column' onKeyDown={getlogged}>
            <Card className='shadow-sm border-radius align-self-center bg-secondary' >
                <Card.Header className='bg-dark text-white d-flex justify-content-between'>
                    <span className='font-weight-bold'>e1maxChat</span>
                    <span>Log In</span>
                </Card.Header>
                <Card.Body className='py-3 bg-white'>
                    <Form.Control 
                        type='email' 
                        placeholder='username' 
                        className='my-3' 
                        name='username' 
                        isInvalid={errors.username}
                        onChange={handleChange}
                    />
                    <Form.Control
                        type='password' 
                        className='mb-4' 
                        placeholder='password' 
                        name='password' 
                        onChange={handleChange}
                        isInvalid={errors.password}
                    />

                    <Row>
                        <Col xs='7'>
                            <Button 
                                variant='success' 
                                className='font-weight-bold'
                                onClick={handleSubmit}>Sign In
                            </Button>
                        </Col>
                        <Col xs='' className='d-flex  '>
                            <NavLink to = '/register' className='text-muted my-auto'>Register</NavLink>
                        </Col>
                    </Row>
                    <div className='mt-4 text-muted small text-center'>e1maxSystems {new Date().getFullYear()}</div>
                </Card.Body>
            </Card>
            <Toast message = {toastMessage} close={setToastMessage}/>
        </Container>
    )
}

export default Login;